import { Api } from './axios-config';
import { IAppointmentView } from './appointmentService';
import { ThemePreference } from '../../constants/themePreference';

export interface IUserView {
  id: number;
  name: string;
  firstName: string;
  email: string;
  cpf?: string;
  phone?: string;
  gender: number;
  userRoles: number[];
  profilePicture?: string;
  emailConfirmed: boolean;
  phoneConfirmed: boolean;
  birthDate?: string;
  themePreference?: ThemePreference;
  appointments: IAppointmentView[];
}

const get = async (notBusinessAdmin: boolean): Promise<IUserView[]> => {
  try {
    const queryParams = {
      notBusinessAdmin: notBusinessAdmin?.toString()
    };

    const { data } = await Api.get<IUserView[]>('/user', {
      params: queryParams
    });

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IUpdateUser {
  id: number;
  name: string;
  email: string;
  cpf?: string;
  phone?: string;
  gender: number;
  userRoles: number[];
  profilePicture?: string;
  birthDate?: string;
}

const update = async (body: IUpdateUser): Promise<IUserView> => {
  try {
    const { data } = await Api.put(
      '/user',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const uploadFile = async (id: number, file: FormData): Promise<string> => {
  try {
    const { data } = await Api.post<string>(
      `/user/${id}/upload`, file
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const deleteFile = async (id: number): Promise<string> => {
  try {
    const { data } = await Api.delete<string>(
      `/user/${id}/profile-picture`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const confirmEmail = async (email: string, token: string): Promise<string> => {
  try {
    const { data } = await Api.get<string>(
      `/user/confirm-email?email=${email}&token=${token}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const updateTheme = async (themePreference: ThemePreference): Promise<void> => {
  await Api.patch('/user/theme', { themePreference });
};

export const userService = {
  update,
  get,
  uploadFile,
  deleteFile,
  confirmEmail,
  updateTheme,
};
